// CHANGE_02: the product name as a SINGLE shared constant. Renaming the app later
// is a one-line edit here — never hardcode the name in components. Mirrors the
// backend settings.app_name.
export const APP_NAME = 'BranchCAD';
